import React from 'react';
import './Hero.css';

function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="hero">
      <div className="hero-background">
        <div className="gradient-orb orb-1"></div>
        <div className="gradient-orb orb-2"></div>
        <div className="gradient-orb orb-3"></div>
      </div>
      
      <div className="container hero-content">
        <div className="hero-text">
          <h1 className="hero-title fade-in-up">
            Transform Your Ideas Into
            <span className="gradient-text"> Powerful Apps</span>
          </h1>
          <p className="hero-subtitle fade-in-up" style={{ animationDelay: '0.2s' }}>
            We create stunning web applications and native mobile apps for iOS and Android. 
            Your vision, expertly crafted into seamless digital experiences that users love.
          </p>
          <div className="hero-cta fade-in-up" style={{ animationDelay: '0.4s' }}>
            <button className="primary-button" onClick={scrollToContact}>
              Start Your Project
              <span className="button-icon">→</span>
            </button>
            <button className="secondary-button" onClick={() => document.getElementById('services').scrollIntoView({ behavior: 'smooth' })}>
              Explore Services
            </button>
          </div>
          <div className="hero-stats fade-in-up" style={{ animationDelay: '0.6s' }}>
            <div className="stat">
              <div className="stat-number">100+</div>
              <div className="stat-label">Projects Delivered</div>
            </div>
            <div className="stat">
              <div className="stat-number">98%</div>
              <div className="stat-label">Client Satisfaction</div>
            </div>
            <div className="stat">
              <div className="stat-number">3</div>
              <div className="stat-label">Platforms Covered</div>
            </div>
          </div>
        </div>
        
        <div className="hero-visual fade-in-up" style={{ animationDelay: '0.3s' }}>
          <div className="device-mockup">
            <div className="phone-mockup">
              <div className="phone-screen">
                <div className="screen-content">
                  <div className="app-bar"></div>
                  <div className="app-content">
                    <div className="content-block"></div>
                    <div className="content-block"></div>
                    <div className="content-block small"></div>
                  </div>
                </div>
              </div>
            </div>
            <div className="tablet-mockup">
              <div className="tablet-screen">
                <div className="screen-content">
                  <div className="app-bar"></div>
                  <div className="app-grid">
                    <div className="grid-item"></div>
                    <div className="grid-item"></div>
                    <div className="grid-item"></div>
                    <div className="grid-item"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
